import { z } from 'zod';

// Service Request DTO — @musinsa/apis-curator getCurationsMe 요청과 동일
export const GetCurationsMeServiceRequestSchema = z
  .object({
    page: z.number().int().min(1),
    // NOTE: 큐레이션이 상품 목록을 들고있어서, 최대 10개 미만으로 요청받음
    size: z.number().int().min(1).max(10),
    curationId: z.string().optional(),
    type: z.enum(['GOODS', 'SNAP2']).optional(),
  })
  .describe('GetCurationsMeServiceRequestSchema');
export type GetCurationsMeServiceRequest = z.infer<typeof GetCurationsMeServiceRequestSchema>;

const MyCurationGoodsItemSchema = z
  .object({
    goodsNo: z.number().int(),
    goodsName: z.string(),
    brandName: z.string(),
    imageUrl: z.string(),
    price: z.number().int(),
    salesRate: z.number().int(),
    isSoldOut: z.boolean(),
    linkUrl: z.string(),
    isLiked: z.boolean(),
    likeCount: z.number().int(),
    reviewScore: z.string(),
    reviewCount: z.number().int(),
    existsCoupon: z.boolean(),
    brandNo: z.number().optional().nullable(),
    normalPrice: z.number().int().optional().nullable(),
    couponPrice: z.number().int().optional().nullable(),
    couponSaleRate: z.number().int().optional().nullable(),
    extraDiscountAmount: z.number().int().nullish(),
    finalPrice: z.number().int().nullish(),
    finalDiscount: z.number().int().nullish(),
    isLowestPrice: z.boolean().nullish(),
    isExclusive: z.boolean(),
    hasOptionPrice: z.boolean().optional().nullable(),
    largeCategoryNo: z.number().optional().nullable(),
    largeCategoryName: z.string().optional().nullable(),
    middleCategoryNo: z.number().optional().nullable(),
    middleCategoryName: z.string().optional().nullable(),
    smallCategoryNo: z.number().optional().nullable(),
    smallCategoryName: z.string().optional().nullable(),
    totalQuantity: z.number().int().min(0).optional().nullable(),
    hasNextPage: z.boolean(),
    nextPage: z.number().int().optional(),
  })
  .describe('MyCurationGoodsItemSchema');

/** getCurationsMe API `CurationSnapItemSchema` 기준 */
const MyCurationSnapItemSchema = z
  .object({
    id: z.string(),
    imageUrl: z.string(),
    linkUrl: z.string(),
  })
  .describe('MyCurationSnapItemSchema');

export const MyCurationItemSchema = z
  .object({
    curationId: z.string(),
    title: z.string(),
    description: z.string().nullable(),
    type: z.enum(['GOODS', 'SNAP2']).nullable(),
    ordNo: z.number().int(),
    isPublished: z.boolean().nullable(),
    goodsItems: z.array(MyCurationGoodsItemSchema),
    snapItems: z.array(MyCurationSnapItemSchema),
  })
  .describe('MyCurationItemSchema');

export type MyCurationItem = z.infer<typeof MyCurationItemSchema>;
export type MyCurationGoodsItem = z.infer<typeof MyCurationGoodsItemSchema>;
export type MyCurationSnapItem = z.infer<typeof MyCurationSnapItemSchema>;

export const GetCurationsMeServiceResponseSchema = z.object({
  total: z.number(),
  list: z.array(MyCurationItemSchema),
  pagination: z.object({
    currentPage: z.number(),
    pageSize: z.number(),
    hasNextPage: z.boolean(),
    nextPage: z.number().optional(),
  }),
});

export type GetCurationsMeServiceResponse = z.infer<typeof GetCurationsMeServiceResponseSchema>;
